import { html, LitElement } from 'lit';
import styles from './toujou-portfolio-gallery.css';

class ToujouPortfolioGallery extends LitElement {
  static get is() {
    return 'toujou-portfolio-gallery';
  }

  static get styles() {
    return styles;
  }

  static get properties() {
    return {
      _currentImageIndex: { type: Number },
      _imageCount: { type: Number },
      _sliderContent: { type: Object },
      _gliderInitialized: { type: Boolean },
      _slider: { type: Object },
      _sliderLoaded: { type: Boolean },
      _gliderEventReceived: { type: Boolean },
    };
  }

  render() {
    return html`
      <slot id="slider" name="slider" @slotchange="${this._handleSlotChange}"></slot>
      <slot id="button" name="button" @click="${this._handleButtonClick}"></slot>
      <p class="pagination">
        <span class="pagination__current">${this._currentImageIndex}</span>
        <span class="pagination__separator">/</span>
        <span class="pagination__total">${this._imageCount}</span>
      </p>
    `;
  }

  constructor() {
    super();
    this._currentImageIndex = 1;
    this._imageCount = 0;
    this._sliderContent = null;
    this._gliderInitialized = false;
    this._sliderLoaded = false;

    this._mql = window.matchMedia('(max-width: 840px)');
    this._mql.addEventListener('change', () => {
      this._currentImageIndex = this._activeSlideIndex;
      this._imageCount = this._totalImageCount;
    });

    this._handleGliderLoaded = this._handleGliderLoaded.bind(this);
    this._handleGliderSlideVisible = this._handleGliderSlideVisible.bind(this);
  }

  _handleSlotChange() {
    const sliderSlot = this.shadowRoot?.querySelector('#slider');
    if (!sliderSlot) return;

    const sliderElements = sliderSlot.assignedElements({ flatten: true });
    this._sliderContent = sliderElements[0] || null;

    this._imageCount = this._totalImageCount;
    this._sliderLoaded = true;

    this._tryInitSlider();
  }

  get _firstSliderImage() {
    return this._sliderContent?.querySelector('.slider__link') || null;
  }

  get _totalImageCount() {
    return this._sliderContent?.querySelectorAll('.glider-slide').length || 0;
  }

  get _activeSlideIndex() {
    const activeSlide = this._sliderContent?.querySelector('.glider-slide.visible');
    return activeSlide ? +activeSlide.getAttribute('data-gslide') + 1 : 1;
  }

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('glider-loaded', this._handleGliderLoaded);
    this.addEventListener('glider-slide-visible', this._handleGliderSlideVisible);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeEventListener('glider-loaded', this._handleGliderLoaded);
    this.removeEventListener('glider-slide-visible', this._handleGliderSlideVisible);
  }

  _handleGliderLoaded() {
    this._tryInitSlider();
  }

  /**
   * Attempts to initialize the slider if both the slider content is loaded and the glider is initialized
   */
  _tryInitSlider() {
    if (this._gliderInitialized || !this._sliderLoaded) {
      return;
    }

    this._sliderEl = this._sliderContent?.querySelector('.slider');
    if (!this._sliderEl) return;

    this._initSlider();
  }

  /**
   * Initializes the slider and the lightbox
   */
  _initSlider() {
    this._imageCount = this._totalImageCount;

    const sliderFrame = this._sliderEl.querySelector('.slider__frame');
    const sliderGlider = sliderFrame?._glider || null;

    if (!sliderGlider) {
      return;
    }

    try {
      sliderGlider.refresh(true);
      this._gliderInitialized = true;
    } catch (error) {
      console.error('TOUJOU: Gallery initialization failed:', error);
    }
  }

  _handleGliderSlideVisible(event) {
    this._currentImageIndex = event.detail.slide + 1;
  }

  _handleButtonClick() {
    const currentVisibleImageLink = this._sliderContent?.querySelector('.glider-slide.visible .slider__link');
    currentVisibleImageLink ? currentVisibleImageLink.click() : this._firstSliderImage?.click();
  }
}

customElements.define(ToujouPortfolioGallery.is, ToujouPortfolioGallery);
